import React from 'react';
import { useParams } from 'react-router-dom';

import useLediumPage from '@client/hooks/useLediumPage';
import { useGlobalStore } from '@client/store/globalStore/context/globalContext';
import { usePageStore } from '@client/store/pageStore/context/pageContext';

import ProjectEditorView from './ProjectEditorView';

const ProjectEditor = () => {
    const {
        globalState: { selectedGroupId },
        globalActions
    } = useGlobalStore();
    const {
        pageState: { formData }
    } = usePageStore();
    const { pageType } = useParams<{ pageType?: string }>();

    const { mainMenu, onSave } = useLediumPage({
        newItemDefaults: { zoneId: selectedGroupId },
        saveDataMap: () => ({
            name: formData.name,
            description: formData.description,
            recipeId: formData.recipeId,
            spectrogramMap: formData.spectrogramMap,
            startTime: formData.startTime,
            pauseTime: formData.pauseTime,
            running: formData.running || false,
            zoneId: formData.zoneId
        })
    });

    React.useEffect(() => {
        if (!formData.loaded) {
            return;
        }
        if (pageType !== 'new' && formData.zoneId && formData.zoneId !== selectedGroupId) {
            globalActions.zones.setSelectedGroup(formData.zoneId as string);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formData.loaded]);

    if (!formData.loaded) {
        return null;
    }

    return <ProjectEditorView onClose={mainMenu} onSave={onSave} />;
};

export default ProjectEditor;
